module.exports = __webpack_public_path__ + "assets/icons/ic_broken_image-481a.svg";